import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React from "react";

export default function DialogUserNominations({open, onClose, personWithNominations}) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth={'md'} fullWidth>
            <DialogTitle>Nominations de {personWithNominations.firstName} {personWithNominations.lastName}</DialogTitle>
            <DialogContent>
                <TableContainer >
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Catégorie</TableCell>
                                <TableCell>Nominations</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {personWithNominations.nominations && personWithNominations.nominations.map(nomination => (
                                <TableRow key={nomination.id}>
                                    <TableCell>{nomination.category.name}</TableCell>
                                    <TableCell>{nomination.reason}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>OK</Button>
            </DialogActions>
        </Dialog>
    );
}
